"use client";

import TradingStyleBadge from "@/app/components/TradingStyleBadge";

// Predexon outage: ocultar chip de credibilidad (winRate/style vienen de Predexon)
const HIDE_PREDEXON = process.env.NEXT_PUBLIC_HIDE_PREDEXON_TABS === "true";

interface PredexonData {
  primaryStyle?: string | null;
  winRate?: number | null; // 0-100 (already multiplied)
  roi?: number | null; // decimal (e.g. 0.5 = 50%)
  totalPnl?: number | null;
  trades?: number | null;
  wins?: number | null;
  losses?: number | null;
}

interface CredibilityChipProps {
  predexon?: PredexonData | null;
  className?: string;
}

export default function CredibilityChip({ predexon, className = "" }: CredibilityChipProps) {
  // Sin hooks en este componente → guard directo al inicio es seguro
  if (HIDE_PREDEXON) return null;
  if (!predexon) return null;
  const { primaryStyle, winRate, wins, losses, totalPnl } = predexon;

  // Need at least style or win rate to show anything
  if (!primaryStyle && winRate == null) return null;

  const fmtPnl = (v: number) => {
    const abs = Math.abs(v);
    const s = v >= 0 ? "+" : "-";
    return abs >= 1_000_000 ? `${s}$${(abs / 1_000_000).toFixed(1)}M`
      : abs >= 1_000 ? `${s}$${(abs / 1_000).toFixed(0)}K`
      : `${s}$${abs.toFixed(0)}`;
  };

  return (
    <span className={`inline-flex items-center gap-1.5 flex-wrap ${className}`}>
      {primaryStyle && <TradingStyleBadge style={primaryStyle} size="sm" />}
      {winRate != null && (
        <span className="text-[10px] text-gray-500 dark:text-gray-400 tabular-nums">
          {winRate.toFixed(0)}% WR
        </span>
      )}
      {wins != null && losses != null && (
        <span className="text-[10px] text-gray-500 dark:text-gray-400 tabular-nums">
          {wins}W-{losses}L
        </span>
      )}
      {totalPnl != null && totalPnl !== 0 && (
        <span className={`text-[10px] font-semibold tabular-nums ${totalPnl >= 0 ? "text-emerald-500" : "text-red-500"}`}>
          {fmtPnl(totalPnl)}
        </span>
      )}
    </span>
  );
}
